import styled from 'styled-components';

export const HeaderTrial = styled.span`
  font-size: 14px;
  color: #ffc551;
  font-family: Linotte Regular;
  margin-left: 6px;
  vertical-align: bottom;
`;
